<template>
  <div class="h-full w-full packages-page">
    <div v-if="isDesktop" class="h-full w-full">
      <vs-row vs-w="12" class="m-4">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="3" v-for="(item, index) in signatures" :key="index+1">
          <vx-card class="mb-5 pb-5 card-plan mr-5 pt-5">
            <h4 class="mb-5 center title-plan">{{getFieldName('name', item)}}</h4>
            <div class="description-package mb-5">{{getFieldName('desc', item)}}</div>
            <hr class="mt-5 mb-5">
            <div class="mb-4">
              <ul v-for="(content, indexx) in getFieldName('content', item)" :key="indexx+11" class="">
                <li>{{content}}</li>
              </ul>
            </div>
            <div class="flex justify-center mt-4">
              <vs-button class="btn-plan" @click="redirectLink(item)"> {{ $t('PACKAGES').I_Want_To_Hire }} </vs-button>
            </div>
          </vx-card>
        </vs-col>
      </vs-row>
      <!-- <swiper :options="swiper1Option" :key="$vs.rtl">
          <swiper-slide class="content-package-swipe" v-for="(item, index) in signatures" :key="index+1">
            <div class="vx-col mr-2 ml-3 content-package-swipe">
              <vx-card class="mb-5 pb-5 card-plan mr-5 pt-5">
                <h4 class="mb-5 center title-plan">{{getFieldName('name', item)}}</h4>
                <div class="description-package mb-5">{{getFieldName('desc', item)}}</div>
                <hr class="mt-5 mb-5">
                  <ul v-for="(content, indexx) in getFieldName('content', item)" :key="indexx+11" class="">
                    <li>{{content}}</li>
                  </ul>
                <div class="flex justify-center">
                <vs-button class="btn-plan" @click="redirectLink(item)"> {{ $t('PACKAGES').I_Want_To_Hire }} </vs-button>
                </div>
              </vx-card>
            </div>
          </swiper-slide>
          <div class="swiper-pagination packages" slot="pagination"></div>
      </swiper> -->
          <!-- <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div> -->
    </div>
    <div v-if="isDesktop" class="v-nav-menu-swipe-area" v-hammer:swipe.right="onClose"></div>
    <div v-if="!isDesktop" class="h-full w-full">
      <swiper :options="swiper2Option" :key="$vs.rtl">
          <swiper-slide v-for="(item, index) in signatures" :key="index+1">
            <vx-card
              class="mb-5 pb-5"
              :title="getFieldName('name', item)"
            >
            {{getFieldName('desc', item)}}
            <hr class="mt-5 mb-5">
            <ul v-for="(content, indexx) in getFieldName('content', item)" :key="indexx+11" class="">
               <li>{{content}}</li>
            </ul>
            <div class="w-full h-full p-5 mb-5">
              <!-- <vs-button color="primary" class="p-1 m-0 mt-3 w-full" @click="redirectLink(item)">Quero contratar</vs-button> -->
              <vs-button class="btn-login" @click="redirectLink(item)">{{ $t('PACKAGES').I_Want_To_Hire }}</vs-button>
            </div>
          </vx-card>
          </swiper-slide>
          <div class="swiper-pagination packages-mob" slot="pagination"></div>
          <!-- <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div> -->
      </swiper>
    </div>
    <div v-if="!isDesktop" class="v-nav-menu-swipe-area" v-hammer:swipe.right="onClose"></div>
  </div>
</template>

<script>
import AppConstants from "../../appConstants";
import messagesNotifyHelper from "../../helpers/messages-notify-helper";
import {CLIENT_SIGNATURES} from "../../enums/enum-client-signatures";
import userService from "../../providers/userService";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import vSelect from "vue-select";
import Flags from "../../components/translate/Flags";
import { EventBus } from "../../event-bus";
import translateFieldHelper from "../../helpers/translate-field-helper";
import convertDatetimeHelper from "../../helpers/convert-datetime-helper";
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import checkDeviceTypeHelper from "@/helpers/check-device-type-helper";
import "swiper/dist/css/swiper.min.css";
import newsHomeService from '../../providers/newsHomeService';
import biometryHelper from "../../helpers/biometry-helper";

export default {
  components: {
    VuePerfectScrollbar,
    vSelect,
    Flags,
    swiper,
    swiperSlide
  },
  created() {
    EventBus.$emit(
      AppConstants.BUS_EVENT_HEADER_MOBILE_TITLE,
      this.$t("MY_ACCOUNT").Title
    );
    this.loadData();
  },
  data() {
    return {
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.3,
        swipeEasing: true
      },
      currentSignature: {},
      signatures: [],
      displaySentDemoRequestMessage: false,
      swiper2Option: {
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        slidesPerView: 1,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
      }
    };
  },
  computed: {
    swiper1Option() {
      return {
        slidesPerView: this.swiperNumPages,
        spaceBetween: 5,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
      }
    },
    swiperNumPages() {
      if (this.windowWidth >= 1700) {
        return 4;
      }
      if (this.windowWidth >= 1500 && this.windowWidth < 1700) {
        return 3;
      }
      return 2;
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
    isProfileFree() {
      return this.currentSignature.profile == AppConstants.USER_PROFILE.FREE;
    },
    isProfileDemo() {
      return this.currentSignature.profile == AppConstants.USER_PROFILE.DEMO;
    },
    isProfileSubscribe() {
      return (
        this.currentSignature.profile == AppConstants.USER_PROFILE.SUBSCRIBER
      );
    },
    AppActiveUser() {
      return this.$store.state.AppActiveUser;
    },
    isDesktop() {
      return this.$store.state.isDesktop;
    },
    getTitle() {
      return this.isDesktop ? "" : this.$t("USER_SIGNATURE").Title;
    },
    isAuthenticated() {
      return this.$store.state.isAuthenticated;
    }
  },
  watch: {
    "$i18n.locale"() {
      // userService.updateUser(new URLSearchParams(), {language: getLocaleCode(locale)});
      // multi language - when change value request new data from server
      // this.form.language = getLocaleCode(locale);
      // this.loadData(false);
      this.loadData();
    }
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
    isCurrentUserSignature(item) {
      return this.AppActiveUser.signature == item.code;
    },
    openMoreInfo(data) {
      EventBus.$emit(AppConstants.BUS_EVENT_OPENA_ATTENDANCE, `Olá, quero saber mais informações sobre o ${this.getFieldName('name', data)} para contratação.`);
    },
    displayButtonLink(item) {
      return (item.code != CLIENT_SIGNATURES.FREE && item.code != CLIENT_SIGNATURES.LIVE_CONSULTING);
    },
    redirectLink(item) {
      const url = this.getFieldName('link', item);

      if (checkDeviceTypeHelper.isNativeApp()) {
        if (checkDeviceTypeHelper.isReactApp()) {
          biometryHelper.openExternalUrl(url);
        } else {
          cordova.InAppBrowser.open(url, '_system');
        }
      } else {
        window.open(url, '_blank');
      }
    },
    checkSendDemoRequest() {
      userService.checkRequestDemo(new URLSearchParams())
      .then(resp => {
        this.displaySentDemoRequestMessage = resp;
      })
      .catch(err => console.log(err));
    },
    requestDemo() {
      userService.requestDemo(new URLSearchParams())
      .then(() => {
        messagesNotifyHelper.successNotify(
          this.$t('TOAST_NOTIFICATIONS').packRequestDemoTitle,
          this.$t('TOAST_NOTIFICATIONS').packRequestDemoMessage
          );
        this.displaySentDemoRequestMessage = true;
      })
      .catch(err => console.log(err));
    },
    formatDate(val, obj) {
      return convertDatetimeHelper.formatDate(val, obj);
    },
    getFieldName(field, data) {
      return translateFieldHelper.getTranslateField(field, data);
    },
    loadData() {
      this.signatures = [];
      if (this.isAuthenticated) {
        userService.getUserSignatures(new URLSearchParams())
        .then(res => {
          this.signatures = res;
        })
        .catch(err => console.log(err));
      } else {
        newsHomeService.getPlansCache(new URLSearchParams())
        .then(res => {
          this.signatures = res;
        })
        .catch(err => console.log(err));
      }
    },
    onSubmit() {},
    onBack() {
      EventBus.$emit(AppConstants.BUS_EVENT_OPEN_USER_MENU_MOBILE);
      this.$router.back();
    }
  },
  mounted() {
    EventBus.$on(AppConstants.BUS_EVENT_HEADER_MOBILE_BACK, () => {
      this.onBack();
    });
  },
  beforeDestroy() {
    EventBus.$off(AppConstants.BUS_EVENT_HEADER_MOBILE_BACK);
  }
};
</script>

<style lang="scss">
#user-email-config {
  h5 {
    margin-bottom: 10px;
  }
  .vs-col {
    margin-top: 6px;
  }
  .input-switch {
    align-self: center;
  }
}

.row-btn {
  margin: 10px 0px;
}
.custom-scroll-content-my-account {
  height: calc(100% - 100px);
}
.my-account-help-language {
  margin-left: 10px;
}
.required-field {
  margin-left: 2px;
  color: red;
}

.theme-dark {
  .vs__clear {
    background-color: #363c42 !important;
  }
  .vs__open-indicator {
    background-color: #363c42 !important;
  }
}
#my-account-scroll {
  #flags {
    float: left;
  }
}
.theme-dark .ps:hover>.ps__scrollbar-x-rail:hover{
  background-color: #363c42 !important;

}
.theme-dark .ps:hover.ps--in-scrolling.ps--x>.ps__scrollbar-x-rail{
  background-color: #363c42 !important;
}
.theme-dark .ps.ps--in-scrolling.ps--x>.ps__scrollbar-x-rail{
  background-color: #363c42 !important;
}
.card-plan {
  display: flex;
  height: 100%;
  width: 400px;
  box-shadow: none;
  border: 1px solid #DDD;
}
.theme-dark .card-plan {
  border: 1px solid #4d5762;
}
.btn-plan {
  // position: relative !important;
  position: absolute;
  bottom: 0;
  // margin-top: 30px;
}

</style>
